export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7023.9aa8055b.jpg";